module.exports = __webpack_public_path__ + "img/mlc.ed0902d8.png";